'use client'

import { trackPixelEvent } from '@/lib/tracking/track-pixel'
import { useEffect } from 'react'

type TrackingPixelPageProps = {
  data: {
    content_type: string
    content_ids: string
    content_name: string
    content_category: string
    value: string | number
  }
}

export const TrackingPixelPage = ({ data }: TrackingPixelPageProps) => {
  useEffect(() => {
    trackPixelEvent('ViewContent', {
      content_type: data.content_type,
      content_ids: data.content_ids,
      content_name: data.content_name,
      content_category: data.content_category,
      value: data.value,
      currency: 'VND',
    })
  }, [data])

  return null
}
